import { handleActions } from 'redux-actions';
import { COURSE_LIST } from '../actionTypes';
import { niceAudio } from '../initialState';

export default handleActions(
  {
    [COURSE_LIST]: (state, action) => {
      return {
        ...state,
        courseList: action.payload
      };
    }
  },
  niceAudio
);
